import { jsx as _jsx } from "react/jsx-runtime";
import PlaybackRateIcon from "../icons/playback-rate.svg";
import { useTranslations } from "../providers/TranslationsProvider";
import { PlayerControlButtonComponent } from "./PlayerControlButton";
export const PlaybackRateButton = ({ onClick, buttonRef, }) => {
    const translations = useTranslations();
    return (_jsx(PlayerControlButtonComponent, { buttonRef: buttonRef, "aria-label": translations("playback_speed_header"), onClick: onClick, interactive: true, "aria-haspopup": "true", Icon: _jsx(PlaybackRateIcon, {}), hoverText: translations("playback_speed_header") }));
};
